var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('c-header'),_c('c-main'),_c('c-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }